import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import {
  CHD_I18N_OPTIONS,
  CHD_LANG_STORAGE_KEY,
  resolveChdLang,
} from './resources';

/**
 * 持卡人端 i18n 初始化
 * - 从 localStorage 读取已有语言偏好（allinks_chd_lang），仅 zh | en
 * - fallback 语言：zh（N3：'zh' 映射语义等价 PRD「默认 zh-CN」）
 * - 同步初始化（不 await），不阻塞页面渲染
 * - resources：整份 locale 挂 translation，支持 t('dashboard.xxx') / t('common.xxx')
 */
const initialLng =
  typeof window !== 'undefined'
    ? resolveChdLang(localStorage.getItem(CHD_LANG_STORAGE_KEY))
    : 'en';

void i18n.use(initReactI18next).init({
  ...CHD_I18N_OPTIONS,
  lng: initialLng,
});

export default i18n;
export {
  CHD_LANG_STORAGE_KEY,
  resolveChdLang,
  buildChdI18nResources,
  CHD_I18N_OPTIONS,
  type ChdLang,
} from './resources';
export {
  localePath,
  stripLangPrefix,
  replaceLangInPath,
  parseLangFromPath,
  getPreferredLang,
  isChdLang,
} from './localePath';
